/**
 * Enables the "Resume" entry path: a cached venue ref from a recent visit. This is a cache, not
 * a source of truth — `@touchscreen/api-client`'s own storage still owns the session token, and
 * a fresh `POST /session` runs regardless once this venue ref is fed back in.
 */
const KEY = "touchscreen:phone:last_venue_ref";

export function readLastVenueRef(): string | null {
  try {
    return window.localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function writeLastVenueRef(venueRef: string): void {
  try {
    window.localStorage.setItem(KEY, venueRef);
  } catch {
    // Best-effort — losing Resume just means the punter goes through Find Me again next time.
  }
}

export function clearLastVenueRef(): void {
  try {
    window.localStorage.removeItem(KEY);
  } catch {
    // Nothing to do.
  }
}
